import { render, staticRenderFns } from "./step-enviar-recurso.vue?vue&type=template&id=6a18cb52&"
import script from "./step-enviar-recurso.vue?vue&type=script&lang=js&"
export * from "./step-enviar-recurso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports